module.exports = __webpack_public_path__ + "static/media/Pouť-95-MCoppa-3.5e94f595.jpg";